import { chakra } from '@stockx/ui';

const NavInner = chakra('div', {
  baseStyle: {
    height: '90px',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    display: ['none', 'flex'],
    justifyContent: 'space-between',
    alignItems: 'center',
    background: 'neutral.white',
    borderColor: 'neutral.300',
    borderWidth: '0 0 1px 0',
    zIndex: 1024,
  },
});

export default NavInner;
